import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import template from './panelPicker.vdt';
import { BasePicker } from '../datepicker/basepicker';
import { isNullOrUndefined } from 'intact-shared';
import { _$ } from '../../i18n';
import { useFormats } from './useFormats';
import { useValue } from './useValue';
import { useDisabled } from './useDisabled';
import { usePanel } from '../datepicker/usePanel';
import { PanelTypes } from '../datepicker/usePanel';
import { useStep } from './useStep';
import { typeDefs } from './constants';
export var PanelPicker = /*#__PURE__*/function (_BasePicker) {
  _inheritsLoose(PanelPicker, _BasePicker);
  function PanelPicker() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _BasePicker.call.apply(_BasePicker, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.formats = useFormats();
    _this.disabled = useDisabled(_this.formats);
    _this.panel = usePanel(PanelTypes.Time);
    _this.value = useValue(_this.formats, _this.disabled, _this.panel);
    _this.step = useStep(_this.disabled, _this.formats);
    return _this;
  }
  var _proto = PanelPicker.prototype;
  _proto.getPlaceholder = function getPlaceholder() {
    var _this$get = this.get(),
      placeholder = _this$get.placeholder,
      range = _this$get.range;
    if (!isNullOrUndefined(placeholder)) return placeholder;
    return range ? _$('开始时间 ~ 结束时间') : _$('请选择时间');
  };
  _proto.getLabel = function getLabel() {
    return this.value.format();
  };
  return PanelPicker;
}(BasePicker);
PanelPicker.template = template;
PanelPicker.typeDefs = typeDefs;